import { useMemo } from "react";
// MUI
import { Stack } from "@mui/material";

// Helpers
import FilterButton from "@Layouts/components/FloatingTabButtonSelector/FilterButton.tsx";
// Interfaces
type TMultiSelectFilterButtonsProps = {
	filterOptions: string[];
	selectedTab: string;
	disabledTabs?: string[];
	// Callbacks
	decorateLabel?: (label: string, selected: boolean) => React.ReactNode;
	onChangeTab: (tab: string) => void;
};

export default function MultiSelectFilterButtons(props: Readonly<TMultiSelectFilterButtonsProps>) {
	const { filterOptions, selectedTab, disabledTabs = [], decorateLabel, onChangeTab } = props;
	const options = useMemo(() => {
		return filterOptions.map((filter) => {
			const selected = filter === selectedTab;
			return {
				label: filter,
				displayLabel: decorateLabel ? decorateLabel(filter, selected) : filter,
				isDisabled: disabledTabs?.includes(filter),
				selected: filter === selectedTab,
			};
		});
	}, [filterOptions, selectedTab, disabledTabs?.length, decorateLabel]);
	return (
		<Stack direction="row" spacing={3} component={"menu"} role={"menubar"}>
			{options.map((option) => {
				return (
					<FilterButton
						key={option.label}
						label={option.displayLabel}
						isDisabled={option.isDisabled}
						selected={option.selected}
						onToggleSelected={() => {
							onChangeTab(option.label);
						}}
					/>
				);
			})}
		</Stack>
	);
}
